import { httpClient } from "./httpClient";
export const PUBLIC_ROUTES = [
  "/auth/signin",
  "/auth/refresh",
  "/auth/signup",
];
let isRefreshing = false;
let queue = [];

const processQueue = (error, token = null) => {
  queue.forEach((p) => (error ? p.reject(error) : p.resolve(token)));
  queue = [];
};

export const refreshInterceptor = async (error) => {
  const originalRequest = error.config;
if (!error?.config) {
    return Promise.reject(error);
  }
  const requestUrl = originalRequest.url;
  // 🚫 Skip refresh for public/auth routes
  if (PUBLIC_ROUTES.some(route => requestUrl.includes(route))) {
    return Promise.reject(error);
  }
  if (error.response?.status !== 401 || originalRequest._retry) {
    return Promise.reject(error);
  }

  if (isRefreshing) {
    return new Promise((resolve, reject) => {
      queue.push({ resolve, reject });
    }).then((token) => {
      originalRequest.headers.Authorization = `Bearer ${token}`;
      return httpClient(originalRequest);
    });
  }

  originalRequest._retry = true;
  isRefreshing = true;

  try {
    // ✅ NO refresh token here — cookie is sent automatically
    const res = await httpClient.post("/auth/refresh");

    const newaccess_token = res.data.access_token;

    // ✅ Store ONLY access token
    localStorage.setItem("access_token", newaccess_token);

    processQueue(null, newaccess_token);

    originalRequest.headers.Authorization =
      `Bearer ${newaccess_token}`;

    return httpClient(originalRequest);
  } catch (err) {
    processQueue(err);

    // hard logout
    localStorage.removeItem("access_token");
    window.location.href = "/auth/login";

    return Promise.reject(err);
  } finally {
    isRefreshing = false;
  }
};
